export default __webpack_public_path__ + "static/media/chisel.1e0cd51b.png";